import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import Presenter from "./helper/presenter.js";
import RequestProperties from "./helper/request.props.js";
const msg_txt = {
  not_found: "No results found",
  failed: "Load data failed. try again!"
};
export default class SelectQuery extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      textNotFound: msg_txt.not_found,
      optionsData: null,
      value: props.value,
      isLoading: false
    };

    this.isAutomatic = false;
    this.dontSearch = false;
    this.change = false;
    this.initOption = true;
    this.nextState = {};

    this.reload = this.reload.bind(this);
    this.getSuggestionSuccess = this.getSuggestionSuccess.bind(this);
    this.getSuggestionFailed = this.getSuggestionSuccess.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  generateLabel(list, query = "") {
    try {
      if (list.length > 0) {
        return list.map((val, key) => {
          if (typeof this.props.valLabel === "string") {
            val.label = val[this.props.valLabel];
          } else if (Array.isArray(this.props.valLabel)) {
            let label = "";
            for (let i = 0; i < this.props.valLabel.length; i++) {
              if (["(", ")"].includes(this.props.valLabel[i].trim())) {
                label += " " + this.props.valLabel[i];
              } else {
                label += " " + val[this.props.valLabel[i].trim()];
              }
            }
            val.label = label;
          }
          val.value = val[this.props.valKey];
          return val;
        });
      } else if (this.props.isCreatable) {
        return [
          {
            value: query,
            label: query
          }
        ];
      }

      return [];
    } catch (error) {
      return [];
    }
  }

  onBlur(evt) {
    if (
      !this.props.isCreatable ||
      !this.change ||
      evt.target.value.trim() === ""
    ) {
      return;
    }
    this.props.onChange({ value: evt.target.value });
    const str = evt.target.value;
    const optionsData = this.state.optionsData;
    let isFound = false;
    if (str !== "" || str !== null) {
      if (optionsData !== null) {
        isFound = optionsData.find(
          val => val.value.toLowerCase() === str.toLowerCase()
        );
      } else {
        isFound = undefined;
      }
      if (isFound === undefined) {
        this.initOptions(str);
      }
    }
  }

  onChange(e) {
    if (e) {
      if (e.length <= 0) {
        //reload karna kosong
        this.dontSearch = false;
        this.change = true;
        this.reload();
      } else {
        //tidak reload, data masih ada
        this.dontSearch = true;
        this.change = false;
      }
    }
    this.props.onChange(e);
  }

  onFocus() {
    if (this.state.optionsData != null) {
      if (this.state.optionsData.length > 0) {
        this.dontSearch = true;
      } else {
        this.dontSearch = false;
      }
    } else {
      this.dontSearch = false;
    }
    this.change = false;
    this.getSuggestion("");
  }

  onInputChange(inputValue) {
    if (inputValue.trim() === "") {
      this.dontSearch = false;
    } else {
      this.dontSearch = false;
    }

    this.change = true;
    this.props.onInputChange(inputValue);

    this.getSuggestion(inputValue);
    return inputValue;
  }

  getSuggestion(query, loading = true) {
    if (this.dontSearch && this.reloading === false) return;

    if (loading)
      this.setState({
        isLoading: true
      });

    Presenter.Search(
      RequestProperties.Search(
        query,
        this,
        this.getSuggestionSuccess,
        this.getSuggestionFailed
      )
    );
  }

  getSuggestionSuccess(params, response) {
    this.reloading = false;
    this.nextState = {
      isLoading: false,
      textNotFound: msg_txt.not_found,
      optionsData: this.props.filterOptions(
        this.generateLabel(
          this.props.isFromMaster ? response.data : response.data.results,
          params.data.Query
        )
      )
    };

    if (this.nextState.optionsData.length === 1)
      if (this.isAutomatic) {
        this.props.onChange(this.nextState.optionsData[0]);
        this.isAutomatic = false;
      }

    this.setState(this.nextState);
    this.props.getOptions(this.nextState.optionsData);
  }

  getSuggestionFailed(params, error) {
    this.setState({
      textNotFound: msg_txt.failed,
      isLoading: false
    });
  }

  reload(query = "", isAutomatic = false) {
    this.reloading = true;
    this.isAutomatic = isAutomatic;
    this.getSuggestion(query);
  }

  initOptions(initOption) {
    this.setState({
      optionsData: this.generateLabel([
        typeof initOption === "object" ? initOption : { value: initOption }
      ])
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.initOption && this.initOption) {
      this.initOptions(nextProps.initOption);
      this.initOption = false;
    }

    // if (nextProps.value !== this.props.value)
    //   this.setState({ value: nextProps.value });
  }

  componentDidMount() {
    if (this.props.initOption && this.initOption) {
      this.initOptions(this.props.initOption);
      this.initOption = false;
    }
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  render() {
    return (
      <Select
        {...this.props}
        // value={this.state.value}
        filterOptions={undefined}
        loadingPlaceholder="Searching..."
        inputProps={{ maxLength: "100" }}
        options={this.state.optionsData}
        isLoading={this.state.isLoading}
        onInputChange={this.onInputChange}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        onChange={this.onChange}
        onCloseResetsInput={!this.props.isCreatable}
        onBlurResetsInput={!this.props.isCreatable}
        onSelectResetsInput={!this.props.isCreatable}
        clearable={this.props.isClearable}
        noResultsText={this.state.textNotFound}
      />
    );
  }
}

SelectQuery.propTypes = {
  isCreatable: PropTypes.bool.isRequired,
  isFromMaster: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  initOption: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  UserReducer: PropTypes.object.isRequired,
  urlKey: PropTypes.string.isRequired,
  valKey: PropTypes.string,
  valLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  extra: PropTypes.string,
  onRef: PropTypes.func,
  getOptions: PropTypes.func,
  filterOptions: PropTypes.func.isRequired
};

SelectQuery.defaultProps = {
  isCreatable: false,
  isClearable: false,
  isFromMaster: false,
  initOption: null,
  extra: null,
  value: null,
  valKey: "value",
  valLabel: "value",
  onRef: () => undefined,
  onInputChange: () => undefined,
  onChange: () => undefined,
  getOptions: () => undefined,
  filterOptions: val => val
};



// WEBPACK FOOTER //
// ./src/App/component/SelectQuery.js